// Analytics utility for GA4 and Meta Pixel tracking
const GA_MEASUREMENT_ID = 'G-PPT6NTZP9L';

export const getLeadSource = (defaultSource = 'website') => {
  if (typeof window === 'undefined') return defaultSource;
  const params = new URLSearchParams(window.location.search || '');
  const utmSource = (params.get('utm_source') || '').trim().toLowerCase();
  if (utmSource === 'chatgpt.com' || utmSource === 'chatgpt') return 'chatgpt';

  try {
    const host = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    if (host === 'chatgpt.com' || host.endsWith('.chatgpt.com') || host === 'chat.openai.com') return 'chatgpt';
  } catch (_) {
    // Ignore malformed referrers and keep the page-specific default source.
  }
  return defaultSource;
};

// Initialize GA4
export const initGA4 = () => {
  if (typeof window !== 'undefined' && !window.gtag) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
  }
};

// Track custom events for GA4 and Meta Pixel
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

// ── DAS event spec ──────────────────────────────────────────────────────────

export const trackCalculatorStarted = (data = {}) => {
  trackEvent('das_flow_start', { event_category: 'calculator', ...data });
};

// step is the 1-based step number — fires das_step_1_complete, das_step_2_complete, etc.
export const trackStepCompleted = (step, data = {}) => {
  trackEvent(`das_step_${step}_complete`, { event_category: 'calculator', step, ...data });
};

export const trackCalculatorCompleted = (data = {}) => {
  trackEvent('das_inputs_complete', { event_category: 'calculator', ...data });
};

export const trackScenarioSelected = (scenario, data = {}) => {
  trackEvent('das_scenario_selected', { event_category: 'calculator', scenario, ...data });
};

export const trackPartialResultsViewed = (data = {}) => {
  trackEvent('das_partial_results_shown', { event_category: 'conversion', ...data });
};

export const trackFullDashboardUnlocked = (data = {}) => {
  trackEvent('das_report_unlocked', { event_category: 'conversion', ...data });
};

export const trackReportDownloaded = (data = {}) => {
  trackEvent('das_report_downloaded', { event_category: 'lead_generation', ...data });
};

// Fires das_lead_captured — consolidates former lead_submitted + lead_form_submit
export const trackLeadFormSubmitted = (data = {}) => {
  trackEvent('das_lead_captured', {
    event_category: 'lead_generation',
    page_location: typeof window !== 'undefined' ? window.location.href : '',
    page_title: typeof document !== 'undefined' ? document.title : '',
    tool_name: 'downsizing_wealth_analysis',
    ...data,
  });
};

// Kept for call-site compatibility — delegates to trackLeadFormSubmitted (same event)
export const trackLeadFormSubmitSuccess = (data = {}) => {
  trackLeadFormSubmitted(data);
};

export const trackStrategyCallBooked = (data = {}) => {
  trackEvent('das_cta_clicked', { event_category: 'conversion', ...data });
};

// Meta Pixel initialization
export const initMetaPixel = () => {
  const PIXEL_ID = '2613529435710167';
  if (typeof window !== 'undefined' && !window.fbq) {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }
};
